module.exports = __webpack_public_path__ + "static/img/背景板(5).c60da320.png";